import { portalFfaCatalog } from "../../../data/portal-ffa-catalog";
import type {
  HudSnapshot,
  WorldState,
} from "../../../features/portal-ffa";
import type { CameraViewRect } from "./types";
import { MINIMAP_H, MINIMAP_W, teamColorCss } from "./markup";

export function paintMinimap(
  canvas: HTMLCanvasElement | null,
  world: WorldState,
  getViewRect: () => CameraViewRect,
  snap: HudSnapshot,
): void {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  void world;
  const mw = snap.mapW;
  const mh = snap.mapH;
  const sx = MINIMAP_W / mw;
  const sy = MINIMAP_H / mh;

  ctx.clearRect(0, 0, MINIMAP_W, MINIMAP_H);
  ctx.fillStyle = "#152033";
  ctx.fillRect(0, 0, MINIMAP_W, MINIMAP_H);
  const margin = portalFfaCatalog.map.outerMargin;
  ctx.fillStyle = "#1a2740";
  ctx.fillRect(
    margin * sx,
    margin * sy,
    (mw - margin * 2) * sx,
    (mh - margin * 2) * sy,
  );
  ctx.strokeStyle = "#3a5080";
  ctx.lineWidth = 1;
  ctx.strokeRect(
    margin * sx,
    margin * sy,
    (mw - margin * 2) * sx,
    (mh - margin * 2) * sy,
  );

  if (snap.alliance) {
    ctx.strokeStyle = "rgba(120, 200, 255, 0.7)";
    ctx.beginPath();
    ctx.arc(
      snap.alliance.centerX * sx,
      snap.alliance.centerY * sy,
      snap.alliance.radius * sx,
      0,
      Math.PI * 2,
    );
    ctx.stroke();
  }
  if (snap.warpCore) {
    ctx.fillStyle = "#ff8a65";
    ctx.beginPath();
    ctx.arc(snap.warpCore.x * sx, snap.warpCore.y * sy, 4, 0, Math.PI * 2);
    ctx.fill();
  }

  // Mana distribution — smaller than unit markers (drawn under units).
  for (const m of snap.minimapMana) {
    ctx.fillStyle = m.ready ? "#6ee7ff" : "rgba(58, 106, 128, 0.55)";
    ctx.beginPath();
    ctx.arc(m.x * sx, m.y * sy, 1, 0, Math.PI * 2);
    ctx.fill();
  }

  for (const d of snap.minimapDots) {
    ctx.fillStyle = d.isSelf ? "#ffd27a" : teamColorCss(d.teamId);
    const r = d.isSelf ? 3.5 : d.role === "master" ? 2.5 : 1.8;
    ctx.beginPath();
    ctx.arc(d.x * sx, d.y * sy, r, 0, Math.PI * 2);
    ctx.fill();
  }

  const view = getViewRect();
  ctx.strokeStyle = "rgba(255, 220, 140, 0.85)";
  ctx.setLineDash([3, 2]);
  ctx.lineWidth = 1;
  ctx.strokeRect(view.x * sx, view.y * sy, view.w * sx, view.h * sy);
  ctx.setLineDash([]);
}
